export function stockMessage(productName, available, requested) {
  return (
    `Existencia insuficiente\n\n` +
    `No es posible continuar con la cantidad solicitada para:\n\n` +
    `${productName || "Producto seleccionado"}\n\n` +
    `Disponibles actualmente: ${available}\n` +
    `Cantidad solicitada: ${requested || "mayor a la disponible"}\n\n` +
    `Por favor ajusta la cantidad para continuar con tu compra.`
  );
}
